import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';

import SoftwareSetup from './../components/SoftwareSetup';

import utils from './../lib/utils';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    softwares: state.softwares,
    dashboard: state.dashboard,
    business: state.business,
    carriers: state.carriers,
    currentDomain: utils.getCookie('domain'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SoftwareSetup);
